import React from 'react';

const CaretDownIcon = ({ size = 8, ...props }) => (
  <svg
    width={Math.round((size * 12) / 8)}
    height={size}
    viewBox='0 0 16 9'
    fill='currentColor'
    {...props}>
    <path d='M6.36314 9L0 1.14442L1.26127 0.122907L6.60658 6.72275L14.9845 0L16 1.26617L6.36314 9Z' />
  </svg>
);

export default CaretDownIcon;
